/*Fonction hover produits*/
$(function () {
    $('.hover-img img').each(function () {
        if (typeof ($(this).attr("data-frz-src")) == "undefined")
        {
            $(this).data('original', this.src)
        }
        else {
            $(this).data('original', $(this).attr("data-frz-src"))
        }
    }).mouseenter(function () {
        $(this)
            .attr('src', $(this).data('hover'))
    }).mouseleave(function () {
        $(this)
            .attr('src', $(this).data('original'))
    })

});
/*END Fonction hover produits*/